import { render, staticRenderFns } from "./vTable.vue?vue&type=template&id=e3121508&scoped=true"
import script from "./vTable.vue?vue&type=script&lang=ts"
export * from "./vTable.vue?vue&type=script&lang=ts"
import style0 from "./vTable.vue?vue&type=style&index=0&id=e3121508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3121508",
  null
  
)

export default component.exports